import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseUkolySearch } from '@/modules/ukoly/filters';

const UkolyList = lazy(() =>
  import('@/modules/ukoly/UkolyList').then((m) => ({ default: m.UkolyList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ukoly',
  component: () => (
    <Suspense fallback={null}>
      <UkolyList />
    </Suspense>
  ),
  validateSearch: parseUkolySearch,
});
